import './src/pages/index.css'
import './src/components/layout.css'

// export function shouldUpdateScroll ({
//   routerProps: { location },
//   getSavedScrollPosition
// }) {

//   window.scrollTo(0, 0)

// }

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }
}
